import { Link } from "react-router-dom";

/**
 * Fallback 404 page for unmatched React routes.
 *
 * @param {Object} [params] Unused route params.
 * @returns {JSX.Element} Not-found message and home link.
 */
export default function PageNotFound(params) {
  return (
    <>
      <h1>404 Page Not Found.</h1>
      <Link to="/drive/directory">Back to Home</Link>
    </>
  );
}
